import { Inject, Injectable, Injector } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class Utilities_ReportService {

  constructor(
    private injector: Injector
  ) {
  }

  public Utilities: Utilities_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

